import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { AccountService } from './account.service';
import { NGXLogger } from 'ngx-logger';
import { DataStorageService } from '../data-storage.service';
import { UserComplaintRequest } from '../../payment/user-complaint-status/user-complaint-req';
import { EkpayUser } from '../../user/ekpay_user';
declare var AesUtil: any;
@Injectable()
export class Principal {
    private userIdentity: any;
    private authenticated = false;
    private authenticationState = new Subject<any>();
    user:EkpayUser;
    constructor(
        private account: AccountService,
        private logger: NGXLogger,
        private dataStorageService: DataStorageService
    ) { }

    authenticate(identity) {
        this.logger.debug('authenticate called...');
        this.userIdentity = identity;
        this.authenticated = identity !== null;
        this.authenticationState.next(this.userIdentity);
    }

    hasAnyAuthority(authorities: string[]): Promise<boolean> {
        return Promise.resolve(this.hasAnyAuthorityDirect(authorities));
    }

    hasAnyAuthorityDirect(authorities: string[]): boolean {
        this.logger.debug('hasAnyAuthorityDirect called...');
        this.logger.debug('this.authenticated...' + this.authenticated);
        this.logger.debug('this.userIdentity...' + this.userIdentity);
        this.logger.debug('this.userIdentity.authorities...' + JSON.stringify(this.userIdentity.roles));
        if (!this.authenticated || !this.userIdentity || !this.userIdentity.roles) {
            return false;
        }

        for (let i = 0; i < authorities.length; i++) {
            if (this.userIdentity.roles.indexOf(authorities[i]) !== -1) {
                return true;
            }
        }

        return false;
    }

    hasAuthority(authority: string): Promise<boolean> {
        if (!this.authenticated) {
            return Promise.resolve(false);
        }

        return this.identity().then((id) => {
            return Promise.resolve(id.authorities && id.authorities.indexOf(authority) !== -1);
        }, () => {
            return Promise.resolve(false);
        });
    }

    identity(force?: boolean): Promise<any> {
        if (force === true) {
            this.userIdentity = undefined;
        }

        // check and see if we have retrieved the userIdentity data from the server.
        // if we have, reuse it by immediately resolving
        if (this.userIdentity) {
            return Promise.resolve(this.userIdentity);
        }

        // retrieve the userIdentity data from the server, update the identity object, and then resolve.
        return this.account.get().toPromise().then((account) => {
            this.logger.debug('account in identity...' + JSON.stringify(account));
            //Decryption Starts
            // var iterationCount = 1000;
            // var keySize = 128;
            // var aesUtil = new AesUtil(keySize, iterationCount);
            // var ciphertext2 = aesUtil.decrypt("8bc82ffe516ea1f1b89dcb529a201d56", "ebb7947b5feabdc0b60f2a694fa259c4", "aks@Samuel#Rishi", account.name);
            // console.log('ciphertext2 is >>>>' + JSON.stringify(ciphertext2));
            //Decryption done
            this.user=account as EkpayUser;
            console.log('user is >>>>' + JSON.stringify(this.user));
            this.dataStorageService.setUserData(this.user);
            if (account) {
                this.userIdentity = this.user;
                this.authenticated = true;
            } else {
                this.userIdentity = null;
                this.authenticated = false;
            }
            this.authenticationState.next(this.userIdentity);
            return this.userIdentity;
        }).catch((err) => {
            this.logger.debug('error in principal service...' + JSON.stringify(err));
            this.userIdentity = null;
            this.authenticated = false;
            this.authenticationState.next(this.userIdentity);
            return null;
        });
    }

    isAuthenticated(): boolean {
        return this.authenticated;
    }

    isIdentityResolved(): boolean {
        return this.userIdentity !== undefined;
    }

    getAuthenticationState(): Observable<any> {
        return this.authenticationState.asObservable();
    }

    getImageUrl(): String {
        return this.isIdentityResolved() ? this.userIdentity.imageUrl : null;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/auth/principal.service.ts